import { TMapRightSidebarProps } from './MapRightSidebar.types';
import React from 'react';
import s from './MapRightSidebar.module.scss';
import { CommunityAssets } from 'src/components/CommunityAssets';
import { MapAlertModal } from 'src/components/MapAlertModal';
import { ModalAddMore } from 'src/components/ModalAddMore';
import { ModalOnboarding } from 'src/components/ModalOnboarding';
import { useSelector } from 'react-redux';
import { selectIsEmbed } from 'src/redux/application/application.selectors';
import classnames from 'classnames';

export const MapRightSidebar: React.FC<TMapRightSidebarProps> = () => {
  const isEmbed = useSelector(selectIsEmbed);

  return (
    <div className={classnames(s.container, { [s.containerEmbed]: isEmbed })}>
      <ModalAddMore inline />
      <ModalOnboarding inline />
      <CommunityAssets />
      <MapAlertModal />
    </div>
  );
};
